module.exports = __webpack_public_path__ + "static/media/product4.05ffabf0.png";